import { systemEngineEnvironment } from "services/environment/systemEngine";

export const deleteTable = async (database: string, tableName: string) => {
  const result = await systemEngineEnvironment.execute(
    `DROP TABLE IF EXISTS "${tableName}"`,
    { database }
  );
  return result;
};
